import type { TipConfigResponse, UpdateTipConfigRequest } from '@jq4race/shared';

import { request } from './client.js';

export async function getLocationTipConfig(locationId: string): Promise<TipConfigResponse> {
  return request<TipConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/tip-config`,
    { method: 'GET' },
  );
}

export async function updateLocationTipConfig(
  locationId: string,
  input: UpdateTipConfigRequest,
): Promise<TipConfigResponse> {
  return request<TipConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/tip-config`,
    { method: 'PUT', body: input },
  );
}
